import React from "react";
import { Card, CardContent, Typography, Box, IconButton } from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

const StatsCard = ({ title, value,
   icon = <CalendarTodayIcon sx={{ fontSize: 18, color: "#6366F1" }} />,
   sx }) => {
  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: "12px",
        border: "1px solid #E6E8EC",
        height: "100%",
        width: "100%",
        ...sx
      }}
    >
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          padding: "13px",
          paddingBottom: "13px !important",
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography
            variant="body2"
            sx={{
              color: "#4B5563",
              fontWeight: 500,
            }}
          >
            {title}
          </Typography>

          <Box
            sx={{
              background: "#EEF2FF",
              width: 32,
              height: 32,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "8px",
            }}
          >
            {icon ? icon : (
              <CalendarTodayIcon
                sx={{ fontSize: 18, color: "#6366F1" }}
              />
            )}
          </Box>
        </Box>

        <Typography
          variant="h4"
          sx={{
            fontWeight: 600,
            color: "primary",
          }}
        >
          {value.toString().padStart(2, "0")}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default StatsCard;